module.exports = __webpack_public_path__ + "static/img/leumicard.dea3791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/leumicard.jpg
// module id = Oqcw
// module chunks = 6